import { asImages } from '@lss/common/src/shell/Image';
import ImageClass from "../../src/shell/Image";
import { TimageINT } from '../../src/store/slices/gameObjectSlice';
import { parseRequire } from "../../src/utils/parseImageUrl";

export const othersProfilesPics = asImages({

    JennyProfilePic1: { url: parseRequire(require("@lss/common/game/assets/images/Extras/JennyProfilePic1.webp")) },
    
    vanessaProfilePic: { url: parseRequire(require("@lss/common/game/assets/images/Extras/VanessaProfilePic1.webp")) },
    vanessaWallpaper: { url: parseRequire(require("@lss/common/game/assets/images/Extras/VanessaWallpaper1.webp")) },
});
